var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-tab-pane",
    { attrs: { name: "general" } },
    [
      _c("div", { staticClass: "row gutter-x-xl" }, [
        _c("div", { staticClass: "col-12 col-md-3" }, [
          _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
            _vm._v(_vm._s(_vm.$t("avatar")))
          ]),
          _c("p", { staticClass: "text-faded" }, [
            _vm._v(_vm._s(_vm.$t("image_hint")))
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-12 col-md-9" },
          [
            _c(
              "image-input",
              {
                attrs: {
                  uploadEndpoint: _vm.uploadAvatar,
                  deleteEndpoint: _vm.removeAvatar,
                  imageUrl: _vm.userAvatar,
                  imageType: _vm.$t("avatar")
                }
              },
              [
                _c("user-avatar", {
                  staticClass: "q-display-3",
                  attrs: {
                    slot: "placeholder",
                    user: _vm.user,
                    height: "160px",
                    width: "160px"
                  },
                  slot: "placeholder"
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("hr"),
      _c("div", { staticClass: "row gutter-x-xl" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-3" },
          [
            _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
              _vm._v(_vm._s(_vm.$t("account")))
            ]),
            _c(
              "i18n",
              {
                staticClass: "text-faded",
                attrs: { tag: "p", path: "account_hint" }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "primary-link",
                    attrs: { place: "securitySettings", href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.$emit("selectTab", "security")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("security_settings")) +
                        "\n        "
                    )
                  ]
                )
              ]
            )
          ],
          1
        ),
        _c("div", { staticClass: "col-12 col-md-9" }, [
          _c(
            "form",
            {
              staticClass: "settings-form",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.handleSaveChanges($event)
                }
              }
            },
            [
              _c(
                "q-field",
                {
                  attrs: {
                    error: _vm.errors.has("firstName"),
                    "error-label": _vm.errors.first("firstName")
                  }
                },
                [
                  _c("q-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate.disable",
                        value: "required|min:1|max:255",
                        expression: "'required|min:1|max:255'",
                        modifiers: { disable: true }
                      }
                    ],
                    attrs: {
                      name: "firstName",
                      "float-label": _vm.$t("first_name"),
                      required: ""
                    },
                    model: {
                      value: _vm.userData.data.first_name,
                      callback: function($$v) {
                        _vm.$set(_vm.userData.data, "first_name", $$v)
                      },
                      expression: "userData.data.first_name"
                    }
                  })
                ],
                1
              ),
              _c(
                "q-field",
                {
                  attrs: {
                    error: _vm.errors.has("lastName"),
                    "error-label": _vm.errors.first("lastName")
                  }
                },
                [
                  _c("q-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate.disable",
                        value: "required|min:1|max:255",
                        expression: "'required|min:1|max:255'",
                        modifiers: { disable: true }
                      }
                    ],
                    attrs: {
                      name: "lastName",
                      "float-label": _vm.$t("last_name"),
                      required: ""
                    },
                    model: {
                      value: _vm.userData.data.last_name,
                      callback: function($$v) {
                        _vm.$set(_vm.userData.data, "last_name", $$v)
                      },
                      expression: "userData.data.last_name"
                    }
                  })
                ],
                1
              ),
              _c(
                "q-field",
                {
                  attrs: {
                    error: _vm.errors.has("email"),
                    "error-label": _vm.errors.first("email")
                  }
                },
                [
                  _c("q-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate.disable",
                        value: "required|email|max:255",
                        expression: "'required|email|max:255'",
                        modifiers: { disable: true }
                      }
                    ],
                    attrs: {
                      type: "email",
                      name: "email",
                      "float-label": _vm.$t("email"),
                      required: ""
                    },
                    model: {
                      value: _vm.userData.data.email,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.userData.data,
                          "email",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "userData.data.email"
                    }
                  })
                ],
                1
              ),
              _c("language-input", {
                model: {
                  value: _vm.userData.data.settings.language,
                  callback: function($$v) {
                    _vm.$set(_vm.userData.data.settings, "language", $$v)
                  },
                  expression: "userData.data.settings.language"
                }
              }),
              _c(
                "div",
                { staticClass: "row justify-end" },
                [
                  _c("q-btn", { attrs: { type: "submit", color: "primary" } }, [
                    _vm._v(_vm._s(_vm.$t("save")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("authorization-dialog", { ref: "authorizationDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }